import { ProductCard } from '../ProductCard';

import styles from './AvailableOffers.module.scss';
import { AvailableOffersProps } from './interfaces';

const AvailableOffers = ({
  unavailableProducts,
  currentItems,
}: AvailableOffersProps) => {
  const unavailableIds = unavailableProducts.map((item) => item.id);

  if (!unavailableIds.length) {
    return null;
  }

  const availableItems = currentItems.filter(
    (item) => !unavailableIds.includes(item.id),
  );

  return (
    <div className={styles.root}>
      {availableItems.map((item) => (
        <ProductCard key={item.id} cartItem={item} available={true} />
      ))}
      {unavailableProducts.map((item) => (
        <ProductCard key={item.id} cartItem={item} available={false} />
      ))}
    </div>
  );
};

export default AvailableOffers;
